import { IItemProps } from "devextreme-react/form";
import { modelClone } from "../../base";

export function setItemDataSource(items: IItemProps[], name: string, dataSource: any[]) {
    const index = items.findIndex(c => c.dataField === name);
    const copy: IItemProps = modelClone(items[index]);
    (copy as any).editorOptions.dataSource = dataSource;
    items.splice(index, 1, copy);
    return copy;
}